const cancelEditTeamSettings = (state) => {
  return {
    ...state,
    editSettingsStatus: "show"
  }
}

export default cancelEditTeamSettings